import {
  InputsStack,
  RemoveInputs,
  RffInput,
  RffPasswordInput,
} from '@cast/shared-rff-ui';

import { Stack } from '@cast/design-system';

export const AuthenticationKeysRow = () => {
  return (
    <InputsStack
      name="authKeys"
      sx={{ '& .RffInputsArray-rows': { gap: '16px' } }}
      addRowButtonTestId="alert-add-header-button"
      renderInputsRow={({ index }) => {
        return (
          <Stack
            direction="row"
            flexWrap="nowrap"
            flex="1"
            gap="16px"
            alignItems="center"
          >
            <RffInput
              name={`authKeys[${index}].key`}
              label="Header"
              placeholder="Authorization"
              sx={{ width: '50%' }}
              testId={`alert-header-name-${index}`}
            />
            <RffPasswordInput
              name={`authKeys[${index}].value`}
              label="Key"
              placeholder="Enter key"
              sx={{ width: '50%' }}
              testId={`alert-header-key-${index}`}
              endOutsideAdornment={<RemoveInputs />}
            />
          </Stack>
        );
      }}
    />
  );
};
